const Define = {
    ACCESS_TOKEN : 'access_token'
}

export default Define